import * as Yup from "yup";
import dayjs from "utils/dayjs";
import { users } from "./users";
import { addressValidation } from "./addressValidation";

export const primaryAuthorizedPersonValidation = users
  .concat(
    Yup.object({
      address: addressValidation,
      identifyingId: Yup.string()
        .required("Your ID is required")
        .matches(
          /^((?!666|000|9\d{2})\d{3}-(?!00)\d{2}-(?!0{4})\d{4})|(\d{9})$/,
          "Enter a valid SSN",
        ),
      title: Yup.string()
        .required("Title is required")
        .notOneOf(["Other"], "Title is required"),
      isOwner: Yup.boolean(),
      authorizationConfirmed: Yup.boolean().oneOf(
        [true],
        "You must be authorized to act on behalf of your business.",
      ),
      birthdate: Yup.date()
        .required("Date of birth is required")
        .typeError("Enter a valid date of birth")
        .test("age", "You must be at least 18 years old", function (value) {
          return value ? dayjs().diff(dayjs(value), "year") >= 18 : false;
        })
        .test("age", "Enter a valid date of birth", function (value) {
          return value ? dayjs().diff(dayjs(value), "year") < 150 : false;
        }),
    }),
  )
  .shape({
    location: Yup.object({ id: Yup.string() }),
  });
